export default __webpack_public_path__ + "static/media/arrow_down.c8a4d810.svg";